import { z } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

export const DEFAULT_SMS_BODY_LENGTH = 30;

export const SmsNotificationConfigSchema = z.discriminatedUnion('isEnabled', [
  z.object({
    isEnabled: z.literal(false),
  }),
  z.object({
    isEnabled: z.literal(true),
    body: z.string({ required_error: IS_REQUIRED }).trim().min(1, IS_REQUIRED),
  }),
]);

export type SmsNotificationConfig = z.infer<typeof SmsNotificationConfigSchema>;
